import React, { useEffect, useState } from 'react';
import yaml from 'js-yaml';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { 
  faGlobe, faRobot, faCogs, faComments, 
  faPencilRuler, faCode, faRocket, faEnvelope, 
  faPhone, faMapMarkerAlt, faDatabase 
} from '@fortawesome/free-solid-svg-icons';
import './i18n';
import { useTranslation } from 'react-i18next';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Workflow from './components/Workflow';
import International from './components/International';
import Projects from './components/Projects';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Add FontAwesome icons to library
library.add(
  fab, 
  faGlobe, 
  faRobot, 
  faCogs, 
  faComments, 
  faPencilRuler, 
  faCode, 
  faRocket, 
  faEnvelope, 
  faPhone, 
  faMapMarkerAlt,
  faDatabase
);

function App() {
  const { t, i18n } = useTranslation();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch and parse the YAML content
    fetch('/content.yml')
      .then(response => response.text())
      .then(text => {
        const parsedContent = yaml.load(text);
        setContent(parsedContent);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading content:', error);
        setLoading(false);
      });
  }, []);

  // Set document title based on current language
  useEffect(() => {
    document.title = t('site.title');
  }, [t, i18n.language]);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (!content) {
    return <div className="flex items-center justify-center h-screen">Error loading content</div>;
  }

  return (
    <div className="font-inter">
      <Navbar content={content.navigation} logo={content.site.logo} />
      <Hero content={content.hero} />
      <Services content={content.services} />
      <Workflow content={content.workflow} />
      <International content={content.international} />
      <Projects content={content.projects} />
      <Testimonials content={content.testimonials} />
      <Contact content={content.contact} />
      <Footer 
        content={content.footer} 
        logo={content.site.logo} 
        companyName={t('site.companyName')} 
        year={content.site.year} 
      />
    </div>
  );
}

export default App;
